import { OutlinePrimitive } from './BookOutline';

export interface Page {
  id: number;
  doc: string;
  label: string;
  chapterId: number;
  position?: number;
  anchor?: string;
  index?: number;
}

export const displayPage = (page: Page, index?: number): string => {
  return `${index ? `${index} - ` : ''}${page?.label ? cleanLabel(page.label) : ''}`;
};

const cleanLabel = (labelIn: string): string => {
  let label = `${labelIn}`;
  //Logger.log(`Page cleanLabel: ${labelIn}`);

  if (!label || label === '') {
    return '';
  }

  const firstChar = label?.charAt(0) ?? '';
  const lastChar = label?.charAt(label.length - 1) ?? '';
  if (firstChar && (firstChar === '{' || firstChar === '(' || firstChar === '[')) {
    label = label.substring(1);
  }
  if (lastChar && (lastChar === '}' || lastChar === ')' || lastChar === ']')) {
    label = label.substring(0, label.length - 1);
  }
  return label;
};

export const getPageId = (pageIndex: number) => {
  return `cwai-page-${pageIndex}`;
};

export const getPreviousPage = (pages: Page[], pageId: number | undefined): Page | null => {
  const index = pages.findIndex((page) => page.id === pageId);

  if (index === 0) {
    return pages[0];
  }

  return pages[index - 1];
};

export const getNextPage = (pages: Page[], pageId: number | undefined): Page | null => {
  const index = pages.findIndex((page) => page.id === pageId);

  if (index === pages.length - 1) {
    return pages[pages.length - 1];
  }

  return pages[index + 1];
};

export const getFirstPageOfNextDoc = (
  outline: OutlinePrimitive | null | undefined,
  doc: string | null
) => {
  if (!doc) {
    return null;
  }

  const pages = outline?.pages ?? [];
  const lastPageIndex = pages.map((page) => page.doc).lastIndexOf(doc);

  if (lastPageIndex > -1 && lastPageIndex !== pages.length - 1) {
    return pages[lastPageIndex + 1];
  }

  if (lastPageIndex === -1) {
    const chapters = outline?.chapters ?? [];
    const lastChapterIndex = chapters.map((chapter) => chapter.doc).lastIndexOf(doc);
    if (lastChapterIndex > -1 && lastChapterIndex !== chapters.length - 1) {
      const nextPageId = chapters[lastChapterIndex + 1].pageId;
      return getPageById(pages, nextPageId);
    }
  }

  return null;
};

export const getPageById = (pages: Page[], pageId: number) => {
  return pages.find((page: Page) => page.id === pageId) || null;
};
